import React from 'react';
import MuiAutocomplete from '@mui/material/Autocomplete';
import MuiTextField from '@mui/material/TextField';
import SearchIcon from '../icons/SearchIcon';
import CircularProgress from '@mui/material/CircularProgress';

// Pill search: a soft filled, borderless rounded field. Uses the
// theme's `softFill` fill (not a hardcoded rgba) so it reads correctly in both
// light and dark mode.
const style = {
  input: {
    '.MuiInputBase-root': {
      backgroundColor: (theme) => (theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.06)' : '#F2F2F3'),
      borderRadius: '999px',
      padding: '4px 18px',
      fontSize: '14px',
      fieldset: {
        borderColor: 'transparent !important',
      },
    },
    'input::placeholder': { opacity: 1, color: (theme) => theme.palette.text.inactive },
  },
};

const SearchField = ({ label, placeholder, loading, autoFocus, inputSx, hideStartIcon, ...other }) => {
  return (
    <MuiAutocomplete
      freeSolo
      filterOptions={(x) => x}
      disableClearable
      loading={loading}
      renderInput={(params) => (
        <MuiTextField
          {...params}
          autoFocus={autoFocus}
          sx={{ ...style.input, ...inputSx }}
          InputLabelProps={{ shrink: true }}
          InputProps={{
            ...params.InputProps,
            startAdornment: hideStartIcon ? undefined : <SearchIcon color="text.secondary" sx={{ fontSize: 20 }} />,
            endAdornment: loading ? <CircularProgress size={16} color="inherit" /> : null,
          }}
          label={label}
          placeholder={placeholder}
        />
      )}
      {...other}
    />
  );
};

export default SearchField;
